import { createPortal } from 'react-dom';
import { AnimatePresence } from 'framer-motion';
import { useProviderGamification } from '../hooks/useProviderGamification';
import { BadgeNotification } from './BadgeNotification';
import { CelebrationOverlay } from './CelebrationOverlay';

export function GamificationAnimations() {
  const { currentNotification, dismissNotification, isPrestataire } = useProviderGamification();

  if (!isPrestataire) return null;

  return createPortal(
    <AnimatePresence mode="wait">
      {currentNotification &&
        (currentNotification.badge.celebrationType === 'celebration' ? (
          <CelebrationOverlay
            key={currentNotification.badge.id}
            data={currentNotification}
            onDismiss={dismissNotification}
          />
        ) : (
          <BadgeNotification
            key={currentNotification.badge.id}
            data={currentNotification}
            onDismiss={dismissNotification}
          />
        ))}
    </AnimatePresence>,
    document.body,
  );
}
